<template>
  <div>
    <div class="modal-title">{{ place.name }}</div>
    <div class="modal-content">
      <div v-if="place.id" class="modal-detail">
        <progressive-img
          :src="place.image"
          :fallback="require('@/assets/images/no-image.jpg')"
        />
        <div class="float-right">
          <favorite :place="place" />
        </div>
        <p class="modal-comment" v-html="place.detail"></p>
      </div>
    </div>
    <div class="modal-button">
      <departure-datetime-select v-model="datetime" class="mb-4" />
      <a class="button-primary block button-icon icon-left" @click="$emit('createItem', place.id)">
        <svg height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg" class="text-white"><path d="m734.333333 280.666667v2.666666h-2.666666c-.36819 0-.666667.298477-.666667.666667s.298477.666667.666667.666667h2.666666v2.666666c0 .36819.298477.666667.666667.666667s.666667-.298477.666667-.666667v-2.666666h2.666666c.36819 0 .666667-.298477.666667-.666667s-.298477-.666667-.666667-.666667h-2.666666v-2.666666c0-.36819-.298477-.666667-.666667-.666667s-.666667.298477-.666667.666667" transform="translate(-729 -278)"/></svg>
        <span>{{ $t('tour_create_plan_label') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import DepartureDatetimeSelect from './DepatureDatetimeSelect.vue'
import Favorite from '../molecules/Favorite'

export default {
  name: 'PoiDetail',
  components: {
    DepartureDatetimeSelect,
    Favorite
  },
  props: {
    place: {
      type: Object,
      default: function () {
        return {
          id: null,
          name: null,
          detail: null
        }
      }
    }
  },
  computed: {
    datetime: {
      get () {
        return this.$store.getters['condition/getTime']
      },
      set (value) {
        this.$store.dispatch('condition/updateTime', value)
      }
    }
  }
}
</script>

<style>
</style>
